import { Field } from 'formik';
import PropTypes from 'prop-types';

import { TrlSearch } from '»components/atoms/TrlSearch';

import { TrlFieldContainer } from '../TrlFieldContainer';
import { TrlLockedField } from '../TrlLockedField';
import { FormControlStyled } from './TrlSearchInput.styles';

export const TrlSearchInput = ({
  name,
  label,
  placeholder,
  disabled,
  options,
  isRequired,
  isLocked,
  isHidden,
  warningText,
  ...rest
}) => (
  <Field name={name}>
    {({ field, meta, form }) => {
      const selectedOption =
        options.find((option) => option.value === field.value) || null;

      return (
        <FormControlStyled fullWidth isHidden={isHidden} disabled={disabled}>
          <TrlFieldContainer
            label={label}
            isRequired={isRequired && !disabled && !isLocked}
            disabled={disabled}
          >
            {isLocked ? (
              <TrlLockedField
                showAlertIcon={!!warningText}
                value={field.value}
              />
            ) : (
              <TrlSearch
                name={name}
                {...form}
                {...meta}
                {...field}
                {...rest}
                options={options}
                placeholder={placeholder}
                value={selectedOption}
                getOptionLabel={(option) => option?.label || ''}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                onChange={(_, option) => {
                  form.setFieldValue(name, option?.value ?? '');
                }}
                fullWidth
                hasLeftStraip
              />
            )}
          </TrlFieldContainer>
        </FormControlStyled>
      );
    }}
  </Field>
);

TrlSearchInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  options: PropTypes.array,
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  noPaddingTop: PropTypes.bool,
  isHidden: PropTypes.bool,
  isRequired: PropTypes.bool,
  isLocked: PropTypes.bool,
  warningText: PropTypes.string,
};
